/**
 * 알림 API
 * - 타입이 명시된 파라미터 사용
 * - URLSearchParams를 통한 데이터 전송
 */
export default function useNotificationApi() {
  return {
    fetchNotifyInfo: () => {
      return useApi('/api/common/selectNotifyInfo.do', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: '',
      });
    },

    fetchNotifications: (page: number = 1) => {
      const params = new URLSearchParams();
      params.append('page', String(page));
      return useApi('/api/common/selectNotifyList_json.do', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: params.toString(),
      });
    },

    updateNotification: (notifyGbnCd: string, notifyId: string) => {
      const params = new URLSearchParams();
      params.append('notifyGbnCd', notifyGbnCd);
      params.append('notifyId', notifyId);
      return useApi('/api/common/readNotify.do', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: params.toString(),
      });
    },

    deleteNotification: (notifyGbnCd: string, notifyId: string) => {
      const params = new URLSearchParams();
      params.append('notifyGbnCd', notifyGbnCd);
      params.append('notifyId', notifyId);
      return useApi('/api/common/deleteNotify.do', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: params.toString(),
      });
    },
  };
}
